import { create } from 'zustand'
import { produce } from 'immer';
const Cookies = require('universal-cookie').default;
const apiEndpoint = `${process.env.REACT_APP_API_URI}/almanacEntry`;
const cookies = new Cookies();

function newAlmanacEntry() {
  return {
    title : "New Alamanac Entry",
    description : "This is a new entry",
    content : "",
    tags : [ ]
  }
}

const useAlmanacEntryStore = create((set, get) => ({
  almanacEntries : {},
  loaded : false,
  addEntry : () => {
    const newEntry = newAlmanacEntry();
    get().createEntry(newEntry);
  },
  updateEntry : (id, value) => {
    set(
      produce((state) => {
        state.almanacEntries[id] = { ...get().almanacEntries[id], ...value }
      })
    )
  },
  deleteEntry : async (id) => {
    const token = cookies.get('token');
    const response = await fetch(`${apiEndpoint}/${id}?access_token=${token}`, {
        method: "DELETE"
    }).catch(err => {

    });
    if (!response.ok) {
        return false;
    }
  
    let cL = get().almanacEntries;
    delete cL[id];
    set({
      almanacEntries : { ...cL }
    })
  },
  saveEntry : async (id) => {
    const token = cookies.get('token');
    const response = await fetch(`${apiEndpoint}/${id}?access_token=${token}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(get().almanacEntries[id]),
    }).catch(err => {

    });
    if (!response.ok) {
        return false;
    }
    return true;
  },
  fetch : async () => {
    if (get().loaded) return true
    const token = cookies.get('token');
    const response = await fetch(`${apiEndpoint}?access_token=${token}`, {
        method: "GET"
    }).catch(err => {

    });
    if (!response.ok) {
        return false;
    }
  
    const data = await response.json();
    let id_linked = {};
    data.forEach(node => id_linked[node._id]=node);

    set({
      almanacEntries : id_linked,
      loaded : true
    });
  },
  createEntry : async (entry) => {
    const token = cookies.get('token');
    const response = await fetch(`${apiEndpoint}?access_token=${token}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(entry),
    }).catch(err => {

    });
    if (!response.ok) {
        return false;
    }
    const data = await response.json();
    let cL = get().almanacEntries;
    cL = JSON.parse(JSON.stringify(cL));
    cL[data._id] = data;
    set({
      almanacEntries : { ...cL }
    })
  }
}))

export {useAlmanacEntryStore};